import { DataTableColumnHeader } from "@common/components/Table/DataTableColumnHeader";
import { Department } from "@common/utils/graphql";
import { ColumnDef } from "@tanstack/react-table";

export const departmentsTableColumns: ColumnDef<Department>[] = [
  {
    accessorKey: "name",
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Name" />;
    },
    cell: ({ row }) => (
      <div>
        <div>{row.original.name}</div>
        <div className="text-slate">{row.original.displaySubtitle}</div>
      </div>
    ),
  },
  {
    accessorKey: "displaySpendThisMonth",
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Monthly Spend" />;
    },
  },
];
